import React from 'react';
import styled from 'styled-components';
import {
  themeUtils,
  useModal,
  Modal,
  ModalContent,
  Alert,
  notification,
} from '@zen-common/components-base';
import { useNavigation } from 'react-navi';
import { WalletStore } from '@zen/common-app-parts';
import usePreventAction from '../../../../../../utils/usePreventAction';
import PATHS from '../../../../../../paths';
import { getRedirectTo } from '../../../../../../utils/redirectsUtils';
import TakeModalProcess from './TakeModalProcess';

const { color, space, fontSize, radius } = themeUtils;

const StyledTakeButton = styled.button`
  cursor: pointer;
  color: ${color('text')};
  transition: background-color 0.2s ease;
  background-color: ${color('secondary')};
  border: 1px solid ${color('borderDark')};
  font-size: ${fontSize('xs')};
  padding: ${space('xxs')} ${space('sm')};
  margin-top: ${space(1)};
  margin-bottom: ${space(1)};
  border-radius: ${radius(1)};
  font-weight: 500;

  &:focus {
    outline: 0;
  }
  &:hover {
    background-color: ${color('bg5')};
  }
`;

/**
 * The button in the table
 */
const TakeButton = ({ isBuy, base, quote, price, quantity, order }) => {
  const { show, hide } = useModal();
  const { preventAction } = usePreventAction();
  const navigation = useNavigation();
  const {
    state: { isLoggedIn, hasPassword },
  } = WalletStore.useStore();

  function handleCancel() {
    hide();
  }
  function handleError(error) {
    show(() => (
      <Alert type={Alert.TYPE.ERROR} onDismiss={hide} title="Error">
        {error.message}
      </Alert>
    ));
  }
  function handleSuccess() {
    notification('Order was taken successfully', {
      type: notification.TYPE.SUCCESS,
    });
    hide();
  }

  const openModal = () => {
    if (!preventAction()) {
      show(() => (
        <Modal>
          <ModalContent>
            <TakeModalProcess
              order={order}
              base={base}
              quote={quote}
              isBuy={isBuy}
              price={price}
              quantity={quantity}
              onCancel={handleCancel}
              onSuccess={handleSuccess}
              onError={handleError}
            />
          </ModalContent>
        </Modal>
      ));
    } else if (isLoggedIn) {
      navigation.navigate(
        getRedirectTo({
          base,
          quote,
          path: PATHS.ORDER_BOOK,
        })
      );
    } else {
      navigation.navigate(
        getRedirectTo({
          base,
          quote,
          path: hasPassword && !isLoggedIn ? PATHS.UNLOCK : PATHS.ONBOARDING,
        })
      );
    }
  };
  return <StyledTakeButton onClick={openModal}>Take</StyledTakeButton>;
};

export default TakeButton;
